import { styled, Grid } from "@mui/material";

export const Container = styled(Grid)({
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  width: "1000px",
});
